/**
 * Deterministic seeded PRNG (mulberry32).
 *
 * IMPORTANT: `Math.random()` must never appear in simulation code - see the
 * docs in README.md ("Determinismi"). This is what stands in for it, and there
 * are exactly two legitimate ways to use it:
 *
 *   1. *Authoring-time* data generated once, at module load, from a fixed seed
 *      - for example the tail of the stumble schedule.
 *   2. Inside the simulation, seeded from simulation state that a replay
 *      reproduces exactly - see src/player/Beer.ts, where the sip is rolled
 *      from the step number the press landed on.
 *
 * What is never allowed is a seed the replay does not carry: a clock, a frame
 * count, a counter that survives a reset.
 */
export function mulberry32(seed: number): () => number {
  let a = seed >>> 0;
  return () => {
    a = (a + 0x6d2b79f5) >>> 0;
    let t = a;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

/** Deterministic float in [min, max) from a seeded generator. */
export function randRange(rng: () => number, min: number, max: number): number {
  return min + rng() * (max - min);
}
